import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useAxios } from 'hooks';
import { endPoints } from 'api/endpoints';
import { getLoggedUserFullName, getLoggedUserGPID } from 'utils';

const useIsManager = () => {
    const axios = useAxios();
    const [isManager, setIsManager] = useState(false);

    const managerListApi = useMutation((name) => axios.get(endPoints.order.mangerList, { params: { name } }));

    useEffect(() => {
        const loggedUserName = getLoggedUserFullName();
        const loggedUserGPID = getLoggedUserGPID();

        if (!loggedUserName || loggedUserName === 'FirstName LastName' || !loggedUserGPID) return;

        managerListApi.mutate(loggedUserName, {
            onSuccess: (res) => {
                const managers = Array.isArray(res?.data) ? res.data : [];
                setIsManager(managers.some((m) => m?.gpid === loggedUserGPID));
            },
            onError: () => setIsManager(false),
        });
    }, []);

    return isManager;
};

export default useIsManager;
